import React from 'react';

const pulse = 'animate-pulse rounded-md bg-gray-200/90';

const DashboardSkeleton = () => {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Carregando dashboard">
      <div className="space-y-2">
        <div className={`h-8 w-48 ${pulse}`} />
        <div className={`h-4 w-72 max-w-full ${pulse}`} />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="card">
            <div className="card-content">
              <div className="flex items-center justify-between gap-4">
                <div className="flex-1 space-y-3">
                  <div className={`h-4 w-24 ${pulse}`} />
                  <div className={`h-8 w-20 ${pulse}`} />
                  <div className={`h-3 w-28 ${pulse}`} />
                </div>
                <div className={`h-12 w-12 shrink-0 rounded-lg ${pulse}`} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className={`h-72 rounded-xl border border-gray-100 bg-white ${pulse}`} />
        <div className={`h-72 rounded-xl border border-gray-100 bg-white ${pulse}`} />
      </div>

      <div className={`h-64 rounded-xl border border-gray-100 bg-white ${pulse}`} />
      <div className={`h-48 rounded-xl border border-gray-100 bg-white ${pulse}`} />
    </div>
  );
};

export default DashboardSkeleton;
